export default __webpack_public_path__ + "BackgroundSmartphone.67b76e2.png";